export default __webpack_public_path__ + "static/media/backgroundDark.e4545ffb.svg";